export default __webpack_public_path__ + "static/media/Feedback_Report_Email_Template.6326fc4a.xlsx";